import { isUnlimited } from "src/ui/utils/limit";

import { getFeature } from "@dashboard/shared/limits/utils";
import { useCurrentWorkspaceFeatures } from "@dashboard/workspaces/api/helpers";
import { isLimitReached } from "@dashboard/workspaces/WorkspacesPage.utils";

export const usePolicyLimit = () => {
    const { data: features = [] } = useCurrentWorkspaceFeatures();

    const { max, used = 0 } = getFeature("PolicyLimit", features);
    const unlimited = isUnlimited(max, "PolicyLimit");

    return { max, used, isPolicyLimitReached: !unlimited && isLimitReached(used, max) };
};
